import React from "react";
import CreatePost from "../../components/blog/CreatePost";

const CreatePostPage = () => {
  return (
    <div className="create-post-page">
      <CreatePost />
    </div>
  );
};

export default CreatePostPage;
